export default value => {
  const price = new price(value)
  return price.num.toFixed(2)
}
